import { buildHwApiUrl } from "@hunkware-ui/common";

import { HW_API_URL } from "../../configs";
import { fetcher } from "../../libs";

import { CreateAddressParams, CreateAddressResponse } from "./types";

/**
 * Create the customer's service address, gated by the customer token.
 *
 * **Transport-only migration.** The Node endpoint reproduces the legacy wire shape exactly — the
 * one-element `addresses` list, the `(int)` ids, the `meta` envelope, and every quirk of the engine
 * behind it (see `docs/migrations/location-accounts-addresses/`), so `useNode` changes nothing but
 * where the request goes.
 *
 * The Node URL is **absolute**, which makes axios ignore this client's `/public/website` baseURL
 * while both interceptors still run (snake_case out, camelCase back) — the same shape
 * `accountCreate` uses for `tokens/generate`. Built through `buildHwApiUrl` rather than
 * concatenated, because `VITE_HW_API_URL` is bare `/api` here but scoped elsewhere.
 *
 * `useNode` is the `HunkWare_Account_Location_Core_Node_Migration` treatment — the accounts-family
 * flag, shared with the internal routes rather than a new one (doc 07).
 */
export const createAddress = ({
  locationId,
  accountId,
  token,
  payload,
  useNode = false,
}: CreateAddressParams) =>
  fetcher.post<CreateAddressResponse>(
    useNode
      ? buildHwApiUrl(
          HW_API_URL,
          `/api/v1/public/website/locations/${locationId}/accounts/${accountId}/addresses`,
        )
      : `/locations/${locationId}/accounts/${accountId}/addresses`,
    {
      ...payload,
      name: payload.address,
    },
    {
      params: { token },
    },
  );
